export default "__VITE_ASSET__D1Mpccu3__"